export const environment = {
  production: true,
  enableconsent: true,
  recaptcha: {
    siteKey: '6LfAFjYrAAAAACrGI3P9NskfG2mCWwpQyzO8JWmt'
  },
  instrumentationKey: '75d2d7d5-cdbe-4c82-99ae-8489c57791bc',
  profilePhtotoUrl: 'https://cnptoday.com:443/Badge/Badges/',
  appName: 'PAS Lite',
  apiConfig: {
    scopes: ['api://6355835b-1761-40b4-869b-8d61e078da00/PSAPI.Write'],
  },
  apiUrl: "https://qa-paslite-api.centerpointenergy.com",
  angularAppUrl: "https://qa-paslite.centerpointenergy.com",
  appSettings: {
    snakbarLife: 30000
  },
  appMessages: {
    loadingMesage: 'Loading, please wait..',
    savinggMesage: 'Saving, please wait..',
    missingData: 'Please select required information',
    errorSaving: 'Error saving data, please try again.',
    saveSuccess: 'Data Saved successfully!',
    dataLoaded: 'Data loaded successfully',
    noChangesFound: 'No Changes to be saved',
    noChanges: 'No Changes',
    authError: 'Request failed due to Auth error, please try again.',
    errorFetchingData: 'Error fetching data.',
    unknownError: 'Unfortunately, your request could not be processed. Please check your details and try again later. If errors persist, please contact our team at '
  },
  supportNumbers: {
    texas: '713-207-2222',
    indiana: '800-227-1376',
    default: '713-207-2222'
  },
  EOP: false,
  ENABLEASYNC: false,
  ENABLEDISCLAIMER: false,
  disclaimerScriptUrl: 'https://acc-www.centerpointenergy.com/_catalogs/masterpage/CNPGallery/js/ExternalLinksWarningMessage.js'
}
